import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
  setResetBudget: ['data']
});

const INITIAL_STATE: { isReset?: boolean; productCode?: string; } = { isReset: false };

const setResetBudget = (state = INITIAL_STATE, action: any) => ({ ...action.data });

export default createReducer(INITIAL_STATE, {
  [Types.SET_RESET_BUDGET as any]: setResetBudget
});
